<template lang="pug">
.main
  v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
    v-form(ref="ppbrForm")
      v-text-field.p1(v-model="form.phoneEmail" @keyup.enter="validatePenang" :rules="rules.phoneEmail" outlined hide-details dense solo flat background-color="basic200"   height="40")
        template(v-slot:label)
          .p1.basic600--text Phone number or Email address
      v-text-field.mt-2(color="primary" v-model="project.postcode" type="text" dense solo flat background-color="basic200" outlined height="40" @keyup.enter="validatePenang" :rules="rules.postcode")
        template(v-slot:label)
          .p1.basic600--text Postcode number
      v-btn.button-AA-medium.mb-4.px-4.elevation-0(color="info500" block dark depressed @click="validatePenang" :loading="loading") Continue
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ValidateProjectPenang',
  data: () => ({
    loading: false,
    projectId: null,
    form: {
      phoneEmail: '',
    },
    project: {
      id: null,
      postcode: ''
    },
    rules: {
      phoneEmail: [
        v => !!v || 'Phone number or e-mail address is required'
      ],
      postcode: [
        v => !!v || 'Postcode is required'
      ]
    }
  }),
  mounted () {
    this.project.id = this.$route.query.project
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    validatePenang() {
      if (!this.$refs.ppbrForm.validate()) {
        return
      }
      this.loading = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.project.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].state) {
          if (addresses[0].state == 'Pulau Pinang') {
            this.$axios.get(`/sponsors/${this.project.id}/`)
              .then(resp => {
                if (resp.full) {
                  this.loading = false
                  this.showMessage(['error', this.$t('error_message.sorry_not_eligible')])
                  this.$axios.post(`https://hooks.zapier.com/hooks/catch/1847976/o9jxeeg/?error=quota_full&postcode=${addresses[0].postcode}&email=${this.form.email}`)
                } else {
                  this.$emit('verified', this.form.phoneEmail)
                }
              })
              .catch(() => {
                this.loading = false
                this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              })
          } else {
            this.loading = false
            this.showMessage(['error', this.$t('error_message.sorry_not_eligible')])
            this.$axios.post(`https://hooks.zapier.com/hooks/catch/1847976/o9jxeeg/?error=not_eligible&postcode=${addresses[0].postcode}&phoneEmail=${this.form.phoneEmail}`).catch(() => {})
          }
        } else {
          this.loading = false
          this.showMessage(['error', this.$t('error_message.invalid_postcode_number')])
        }
      })
      .catch(() => {
        this.loading = false
        this.showMessage(['error', this.$t('error_message.invalid_postcode_number')])
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>